import React, { createContext, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getReferralPartner } from '../../../config/referralPartners';

const SignupReferralContext = createContext(null);

export const SignupReferralProvider = ({ children }) => {
  const { referralCode: rawReferralCode } = useParams();
  const referralCode = rawReferralCode?.trim() ? rawReferralCode.trim().toUpperCase() : null;

  const value = useMemo(() => {
    const partner = getReferralPartner(referralCode);

    return {
      referralCode,
      signupPath: referralCode ? `/signup/${referralCode}` : '/signup',
      referredBy: referralCode,
      partner,
      showPartnerLogo: Boolean(partner),
    };
  }, [referralCode]);

  return <SignupReferralContext.Provider value={value}>{children}</SignupReferralContext.Provider>;
};

export const useSignupReferral = () => {
  const context = useContext(SignupReferralContext);

  if (!context) {
    throw new Error('useSignupReferral must be used within SignupReferralProvider');
  }

  return context;
};
